import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import ReactGA from 'react-ga';
import UserUploadedResComponent from '../learning_resource_user/UserUploadedResComponent';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {stateToHTML} from 'draft-js-export-html';

class AffiliateResourceUpload extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            loadingState: true,
            snackbarIsOpen: false,
            addFormOpen: false,
            uploadFormOpen: false,
            uploadDisableButton: true,
            saveButtonDisable: false,
            addedTaxonomyParent: [],
            addedStandard: [],
            addedBuzzword: [],
            addedGrade: [],
    		data:{
                moduleName: '',
                moduleLink: '',
                moduleAuthor: '',
                moduleDescription: EditorState.createEmpty(),
                taxonomyComboDropDown: [],
                standardComboDropDown: [],
                buzzwordDropDown: [],
                gradesDropDown: [],
                moduleDetails: []
    		},
            countData: {
                pendingCount: '',
                approvedCount: '',
                rejectedCount: '',
                holdCount: '',
                totalCount: ''
            },
            fileError: '',
            errorMsg: ''
    	}
    }

    handleTaxonomyParentChange = (option) => {
        this.setState(state => {
            return {
                addedStandard : [],
                addedTaxonomyParent : option
            };
        });
        this.handleFetchAssociatedStandards(option)
    }

    handleFetchAssociatedStandards = (option) => {
        let selectedAspect = []
        let data = Object.assign({}, this.state.data)

        var myAspectArray = option;
        var aspectLength = myAspectArray.length;
        for (var i = 0; i < aspectLength; i++) {
            selectedAspect.push(parseInt(myAspectArray[i].value))
        }

        let value = {
            'selected_aspect' : selectedAspect
        }

        api.userAspectAffiliatedStandards(this.props.user.accessToken, value)
        .then((result) => {
            if (result.status === 'success') {
                data.standardComboDropDown = result.data
                this.setState({data:data})
            }
        })
    }

    handleStandardChange = (option) => {
        this.setState(state => {
            return {
                addedStandard : option
            };
        });
    }

    handleBuzzwordChange = (option) => {
        this.setState(state => {
            return {
                addedBuzzword : option
            };
        });
    }

    handleGradeChange = (option) => {
        this.setState(state => {
            return {
                addedGrade : option
            };
        });
    }

    handleUploadForm = () => {
        this.setState({uploadFormOpen: true, addFormOpen: false})
    }

    handleAddForm = () => {
        this.setState({addFormOpen: true, uploadFormOpen: false})
    }

    handleModuleNameChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.moduleName = e.target.value
        this.setState({data: data}) 
    }

    handleModuleLinkChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.moduleLink = e.target.value
        this.setState({data: data}) 
    }

    handleModuleAuthorChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.moduleAuthor = e.target.value
        this.setState({data: data}) 
    }

    handleModuleDescChange: Function = (editorState) => {
        let data = Object.assign({}, this.state.data)
        data.moduleDescription = editorState
        this.setState({data: data});
    }

    handleCancelUpload = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)

        data.moduleName = ''
        data.moduleLink = ''
        data.moduleAuthor = ''
        data.moduleDescription = ''
        this.setState({uploadFormOpen: false, addFormOpen: false, data: data, addedTaxonomyParent: [], addedStandard: [], errorMsg: '', fileError: '', saveButtonDisable: false})
    }

     validateUpload = (event) =>{
        if (event.target.files[0] === undefined){
            return this.setState({uploadDisableButton: true})
        }
        let file_name = event.target.files[0].name;
        let fileSize = event.target.files[0].size/1024/1024;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

        if ((extension === "pdf") || (extension === "doc") || (extension === "docx")){
            if (fileSize > 10) {
                return this.setState({uploadDisableButton: true, fileError: 'File size exceeds the permisible limit. Please make sure that the file is less than 10 MB.'})
            }
            this.setState({uploadDisableButton: false, fileError: ''})
        }
        else{
            this.setState({uploadDisableButton: true, fileError: 'Invalid File Format. Upload PDF, DOCX or DOC file only.'})
        }
    }

    userModulesFetch = (e) => {
        let data = Object.assign({}, this.state.data)

        api.getUserUploadedModules(this.props.user.accessToken)
        .then((result) => {
            if (result.status === 'success'){
                data.moduleDetails = result.data
                this.setState({data: data})
            }
        })
    }

    fetchModuleCount = (e) => {
        let countData = Object.assign({}, this.state.countData)
        let fetchResourceCount = 'affiliate_partner/modules/count'

        api.getResponse(this.props.user.accessToken, fetchResourceCount)
        .then((result) => {
            if (result.status === 'success') {
                countData.totalCount = result.data.total_count
                countData.approvedCount = result.data.approved_count
                countData.rejectedCount = result.data.rejected_count
                countData.holdCount = result.data.hold_count
                countData.pendingCount = result.data.pending_count
                this.setState({countData: countData})
            }
        })
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        let fetchAspects = 'user/affiliate_partner/aspect_details'
        let getBuzzwords = 'buzzword'
        let getGrades = 'grade'

        return api.getUserResponse(this.props.user.accessToken, fetchAspects)
        .then((result) => {
            if (result.status === 'success') {
                data.taxonomyComboDropDown = result.data
                api.getResponse(this.props.user.accessToken, getBuzzwords)
                .then((result) => {
                    if (result.status === 'success') {
                        data.buzzwordDropDown = result.data
                        api.getResponse(this.props.user.accessToken, getGrades)
                        .then((result) => {
                            if (result.status === 'success') {
                                data.gradesDropDown = result.data
                                this.setState({data: data, loadingState: false})
                                this.userModulesFetch()
                                this.fetchModuleCount()
                            }
                        })
                    }
                })
            }
        })
    }

    handleModuleSave = (e) => {

        e.preventDefault()
        this.setState({saveButtonDisable: true})

        let htmlText = stateToHTML(this.state.data.moduleDescription.getCurrentContent())

        if (htmlText.length > 3000){
            return this.setState({errorMsg: `Description is too long. Please change the description accordingly.`, saveButtonDisable: false})
        }

        if (this.state.addFormOpen === true) {
            if (this.state.data.moduleLink === '') {
                return this.setState({errorMsg: 'Please enter the link of the module before adding a module. All fields are mandatory.', saveButtonDisable: false})
            }
        }

        if ((this.state.data.moduleName === '') || (this.state.addedTaxonomyParent.length === 0) || (this.state.addedStandard.length === 0) || (this.state.addedGrade.length === 0)){
            return this.setState({errorMsg: 'Please enter the necessary details before adding the module. All fields are mandatory.', saveButtonDisable: false})
        }

        let data = Object.assign({}, this.state.data)
        const formData = new FormData(e.target);

        var taxonomyArray = this.state.addedTaxonomyParent;
        var taxonomyLength = taxonomyArray.length;
        let selectedTaxonomyString = []
        for (var z = 0; z < taxonomyLength; z++) {
            selectedTaxonomyString.push(parseInt(taxonomyArray[z].value))
        }

        var standardArray = this.state.addedStandard;
        var standardLength = standardArray.length;
        let selectedStandardString = []
        for (var z = 0; z < standardLength; z++) {
            selectedStandardString.push(parseInt(standardArray[z].value))
        }

        var buzzwordArray = this.state.addedBuzzword;
        var buzzwordLength = buzzwordArray.length;
        let selectedBuzzwordString = []
        for (var z = 0; z < buzzwordLength; z++) {
            selectedBuzzwordString.push(parseInt(buzzwordArray[z].value))
        }

        var gradeArray = this.state.addedGrade;
        var gradeLength = gradeArray.length;
        let selectedGradeString = []
        for (var z = 0; z < gradeLength; z++) {
            selectedGradeString.push(parseInt(gradeArray[z].value))
        }

        formData.append("resourcedesc", htmlText)
        formData.append("standards", selectedStandardString)
        formData.append("aspects", selectedTaxonomyString)
        formData.append("buzzwords", selectedBuzzwordString)
        formData.append("grades", selectedGradeString)
        formData.append("user_resource_type", "Affiliate")

        api.userUploadModule(this.props.user.accessToken, formData)
        .then((result) => {
            if (result.status === 'success') {
                this.setState({saveButtonDisable: false})
                this.handleCancelUpload(e)
                this.userModulesFetch()
                this.fetchModuleCount()
                this.setState({snackbarIsOpen: !this.state.snackbarIsOpen})
            }
            else {
                this.setState({saveButtonDisable: false})
            }
        })
    }

    render() {
        //<GridCell span = "6">
        //    <Reactsel
        //        name="buzzwordlist"
        //        onChange={this.handleBuzzwordChange}
        //        value={this.state.addedBuzzword}
        //        options={this.state.data.buzzwordDropDown}
        //        placeholder="--Select Keywords--"
        //        isMulti>
        //    </Reactsel>
        //</GridCell>

        const { moduleDescription } = this.state.data;
    	let handleUploadForm = this.handleUploadForm
        let handleAddForm = this.handleAddForm
        let handleBackAction = this.handleBackAction
        let handleCancelUpload = this.handleCancelUpload
        let handleModuleSave = this.handleModuleSave
        let userModulesFetch = this.userModulesFetch
        let mainPageContent, addForm, individualModule, infoContent
        let docField, linkField, hiddenComponent, uploadButtonComponent
        let userType = "Affiliate Partner"

        if (this.state.data.moduleDetails.length > 0){
            individualModule = (
                <Grid className="opportunity-list-item">
                    {this.state.data.moduleDetails.map(function(moduleDets){
                        let uniq = Math.random() * moduleDets.id 
                        return (
                            <GridCell span = "12" key = {uniq}>
                                <Card style={{padding: '0px'}}>
                                    <UserUploadedResComponent resourceId = {moduleDets.id}
                                        resourceName = {moduleDets.name}
                                        resourceAuthor = {moduleDets.author}
                                        resourceDescription = {moduleDets.description}
                                        resourceStatus = {moduleDets.status}
                                        resourceLink = {moduleDets.resource_link}
                                        resourceType = {moduleDets.resource_type}
                                        aspects = {moduleDets.aspects}
                                        standards = {moduleDets.standards}
                                        buzzwords = {moduleDets.buzzwords}
                                        grades = {moduleDets.grades}
                                        adminComments = {moduleDets.admin_comments}
                                        submissionDate = {moduleDets.submitted_at}
                                        onHandleResourceUpdate = {userModulesFetch}
                                        isAdmin = {false}
                                        userType = {userType}
                                    />
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }

        let Snackbarcomponent =(
            <Snackbar
                show={this.state.snackbarIsOpen}
                onHide={evt => this.setState({snackbarIsOpen: false})}
                message="Module successfully added/uploaded"
            />
        )

        if (this.state.saveButtonDisable === false) {
            if ((this.state.uploadDisableButton === true) && (this.state.uploadFormOpen === true)){
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised disabled style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
            else{
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
        }
        else {
            uploadButtonComponent = (
                <GridCell span = "3">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }

        //<TextField textarea fullwidth label="Description" rows="2" name="resourcedesc" defaultValue = {this.state.data.moduleDescription} onChange={this.handleModuleDescChange} />

        if ((this.state.addFormOpen === true) || (this.state.uploadFormOpen === true)) {
            addForm = (
                <div>
                    <Card style={{padding: '25px'}}>
                        <div>
                            <form onSubmit= {((e) => this.handleModuleSave(e))} style={{ width: '100%' }}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span="8">
                                        <TextField fullwidth label="Name" autoComplete="off"  name="resourcename" defaultValue = {this.state.data.moduleName} onChange = {this.handleModuleNameChange} style={{ height: '140%' }}/>
                                    </GridCell>
                                    <GridCell span="4">
                                        <TextField fullwidth label="Author" autoComplete="off"  name="resourceauthor" defaultValue = {this.state.data.moduleAuthor} onChange = {this.handleModuleAuthorChange} style={{ height: '140%' }}/>
                                    </GridCell>
                                    <GridCell span="12">
                    					<TextField fullwidth className = 'test_input' label="Link" autoComplete="off"  name="resourcelink" defaultValue = {this.state.data.moduleLink} onChange = {this.handleModuleLinkChange} style={{ height: '140%' }}/>
                					</GridCell>
                                    <GridCell span="12">
                                        <div className = "description-panel" >
                                            <Editor
                                                editorState={moduleDescription}
                                                wrapperClassName="demo-wrapper"
                                                editorClassName="demo-editor"
                                                onEditorStateChange={this.handleModuleDescChange}
                                                toolbar={{
                                                    options:['inline', 'list' ],
                                                    link: { inDropdown: true },
                                                    inline:
                                                        {
                                                            options:['bold', 'italic', 'underline']
                                                        },
                                                }}
                                            />
                                        </div>
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="taxonomylist"
                                            onChange={this.handleTaxonomyParentChange}
                                            value={this.state.addedTaxonomyParent}
                                            options={this.state.data.taxonomyComboDropDown}
                                            placeholder="--Select Aspects--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="standardlist"
                                            onChange={this.handleStandardChange}
                                            value={this.state.addedStandard}
                                            options={this.state.data.standardComboDropDown}
                                            placeholder="--Select Standards--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "12">
                                        <Reactsel
                                            name="gradeslist"
                                            onChange={this.handleGradeChange}
                                            value={this.state.addedGrade}
                                            options={this.state.data.gradesDropDown}
                                            placeholder="--Select Grades--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "12">
                                        <Grid>
                                            {uploadButtonComponent}
                                            <GridCell span = "3">
                                                <Button dense style={{ width: '100%' }} onClick= {((e) => handleCancelUpload(e))}>Cancel</Button>
                                            </GridCell>
                                        </Grid>
                                    </GridCell>
                                </Grid>
                            </form>
                        </div>
                        <StatusMessage error_msg = {this.state.errorMsg} />
                        <StatusMessage error_msg = {this.state.fileError} />
                    </Card>
                </div>
            )
        }

    	if (this.state.loadingState === true) {
            mainPageContent = (
                <div className="loader-component">
                    <div className="loader"></div>
                </div>
            )
        }
        else {
        	mainPageContent = (

        		<Grid className="opportunity-list-item">
        			<GridCell span = "12">
	                    <Card style={{padding: '0px'}}>
	                    	<Grid className="opportunity-list-item">
	                    		<GridCell span = "6">
	                            	<Typography use="headline5">Module Mapping</Typography>
	                           	</GridCell>
	                           	<GridCell span="3">
									<Typography align="left"><a href='https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/centastandards/Standards_Overview.pdf' target="_blank" style={{cursor: 'pointer'}}>Overview of CENTA Standards</a></Typography>
								</GridCell>
								<GridCell span="3">
									<Typography align="left"><a href='https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/centastandards/CENTA_Standards_Complete.pdf' target="_blank" style={{cursor: 'pointer'}}>CENTA Standards Version 3</a></Typography>
								</GridCell>
	                        </Grid>
	                	</Card>
	                </GridCell>
                    <GridCell span = "2">
                        <Button raised style={{ width: '100%' }} onClick = {((e) => handleAddForm(e))}>Add</Button>
                    </GridCell>
                    <GridCell span = "12">
                        {addForm}
                    </GridCell>
                    <GridCell span = "12">
                        <Card style={{padding: '0px'}}>
                            <Grid className="opportunity-list-item">
                                <GridCell span="12">
                                    <Typography use="subtitle"> Total No.of Mappings - {this.state.countData.totalCount}, </Typography>
                                    <Typography use="subtitle"> Pending Mappings - {this.state.countData.pendingCount}, </Typography>
                                    <Typography use="subtitle"> Mappings on Discussion - {this.state.countData.holdCount}, </Typography>
                                    <Typography use="subtitle"> Mappings Misaligned - {this.state.countData.rejectedCount}, </Typography>
                                    <Typography use="subtitle"> Mappings Approved - {this.state.countData.approvedCount} </Typography>
                                </GridCell>
                            </Grid>
                        </Card> 
                    </GridCell>
        		</Grid>
        	)
        }
    	return (
    		<div>
    			{mainPageContent}
    			{individualModule}
                {Snackbarcomponent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateResourceUpload);


// WEBPACK FOOTER //
// ./src/views/affiliate_user/AffiliateResourceUpload.jsx